import { render } from "./ConfigPdpaScreen.vue?vue&type=template&id=1fd3d1b8"
import script from "./ConfigPdpaScreen.vue?vue&type=script&lang=ts"
export * from "./ConfigPdpaScreen.vue?vue&type=script&lang=ts"
script.render = render

export default script